// extracted by mini-css-extract-plugin
module.exports = {"swiper-slide":"FactCardSliderBlock_swiper-slide__EktLT"};